import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { Box, Container, Flex, Text, Spinner, Center, } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import BackNavigation from "../components/BackNavigation";
import RatingStars from "../components/RatingStars";
import { useCustomer } from "../contexts/CustomerProvider";
import { useUserFeedbackHistory } from "../hooks/useUserFeedbackHistory";
const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000; // +5:30
const FeedbackHistoryEntry = ({ item, }) => {
    const parseDate = (createdAt) => {
        try {
            if (Array.isArray(createdAt)) {
                const [year, month, day, hour = 0, minute = 0, second = 0] = createdAt;
                return new Date(year, (month !== null && month !== void 0 ? month : 1) - 1, day !== null && day !== void 0 ? day : 1, hour, minute, second);
            }
            return new Date(createdAt);
        }
        catch {
            return null;
        }
    };
    const d = parseDate(item.createdAt);
    const dIST = d ? new Date(d.getTime() + IST_OFFSET_MS) : null;
    const dateStr = dIST ? format(dIST, "MMM d, yyyy") : "";
    const timeStr = dIST ? format(dIST, "h:mma") : "";
    const hasDateTime = dateStr || timeStr;
    return (_jsxs(Box, { bg: "#181818", borderRadius: "12px", p: 4, mb: 3, border: "1px solid", borderColor: "#363636", children: [_jsxs(Flex, { justifyContent: "space-between", alignItems: "center", mb: 2, children: [_jsx(RatingStars, { rating: item.rating }), hasDateTime && (_jsxs(Flex, { alignItems: "center", gap: 2, children: [_jsx(Text, { fontFamily: "Poppins", fontWeight: 400, fontSize: "10px", color: "#B1B1B1", children: dateStr }), _jsx(Box, { w: "4px", h: "4px", borderRadius: "full", bg: "#B1B1B1", flexShrink: 0 }), _jsx(Text, { fontFamily: "Poppins", fontWeight: 400, fontSize: "10px", color: "#B1B1B1", children: timeStr })] }))] }), item.review && (_jsx(Text, { fontFamily: "Poppins", fontWeight: 400, fontSize: "10px", color: "#FFFFFF", children: item.review }))] }));
};
const FeedbackHistoryPage = ({ pubId }) => {
    const { customerData } = useCustomer();
    const navigate = useNavigate();
    const { data: feedbackHistory, isLoading } = useUserFeedbackHistory(pubId, !!pubId);
    useEffect(() => {
        if (!(customerData === null || customerData === void 0 ? void 0 : customerData.id)) {
            const currentPath = window.location.pathname + window.location.search;
            navigate(`/verify-phone/direct?redirect=${encodeURIComponent(currentPath)}`, { replace: true });
        }
    }, [customerData, navigate]);
    if (!(customerData === null || customerData === void 0 ? void 0 : customerData.id))
        return null;
    const hasFeedbackHistory = feedbackHistory && feedbackHistory.length > 0;
    return (_jsxs(_Fragment, { children: [_jsx(BackNavigation, { heading: "Feedback History" }), _jsx(Box, { bg: "rgba(0, 0, 0, 0.7)", backdropFilter: "blur(12px)", w: "100%", h: "100%", overflow: "hidden", position: "relative", children: _jsx(Container, { w: ["100%", "100%", "100%", "400px"], minH: "100vh", background: "#111111", p: "0", overflow: "hidden", children: _jsx(Box, { px: 4, pt: 24, pb: 8, children: isLoading ? (_jsx(Center, { py: 12, children: _jsx(Spinner, { color: "white", size: "md" }) })) : hasFeedbackHistory ? ((feedbackHistory || []).map((item, idx) => (_jsx(FeedbackHistoryEntry, { item: item }, idx)))) : (_jsx(Center, { py: 12, children: _jsx(Text, { color: "#9D9D9D", fontSize: "sm", children: "No feedback yet" }) })) }) }) })] }));
};
export default FeedbackHistoryPage;
